<template>
  <div class="particles">
    <div id="particles-js"></div>
    <div class="content">
      <h1>Softresource</h1>
      <h3>The web development company</h3>
        <div class="downArrow bounce">
           <img alt="" src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CgogPGc+CiAgPHRpdGxlPmJhY2tncm91bmQ8L3RpdGxlPgogIDxyZWN0IGZpbGw9Im5vbmUiIGlkPSJjYW52YXNfYmFja2dyb3VuZCIgaGVpZ2h0PSI0MDIiIHdpZHRoPSI1ODIiIHk9Ii0xIiB4PSItMSIvPgogPC9nPgogPGc+CiAgPHRpdGxlPkxheWVyIDE8L3RpdGxlPgogIDxwYXRoIGlkPSJFeHBhbmRfTW9yZSIgZmlsbD0iI2ZmZmZmZiIgZD0ibTI0LjI4NSwxMS4yODRjLTIuNzYxNjcsMi43NjIzMyAtNS41MjMzMyw1LjUyNDY3IC04LjI4NSw4LjI4N2wtOC4yODUsLTguMjg4Yy0wLjM5NSwtMC4zOTUgLTEuMDM0LC0wLjM5NSAtMS40MjksMGMtMC4zOTQsMC4zOTUgLTAuMzk0LDEuMDM1IDAsMS40M2w4Ljk5OSw5LjAwMmwwLDBsMCwwYzAuMzk0LDAuMzk1IDEuMDM0LDAuMzk1IDEuNDI4LDBsOC45OTksLTkuMDAyYzAuMzk0LC0wLjM5NSAwLjM5NCwtMS4wMzYgMCwtMS40MzFjLTAuMzkzLC0wLjM5MyAtMS4wMzMsLTAuMzkzIC0xLjQyNywwLjAwMnoiLz4KICA8ZyBpZD0ic3ZnXzEiLz4KICA8ZyBpZD0ic3ZnXzIiLz4KICA8ZyBpZD0ic3ZnXzMiLz4KICA8ZyBpZD0ic3ZnXzQiLz4KICA8ZyBpZD0ic3ZnXzUiLz4KICA8ZyBpZD0ic3ZnXzYiLz4KIDwvZz4KPC9zdmc+" />
        </div>
    </div>

    <!-- <div class="links">
      <p>Provozujeme</p>
      <a href="https://www.futurebooks.cz/" class="external" target="_blank">Futurebooks.cz</a>
    </div>
    <div class="contacts">
      <f7-button large sheet-open=".modal">Kontakt</f7-button>
    </div>-->

    <!-- <f7-sheet class="modal" style="height:auto; --f7-sheet-bg-color: #fff;" swipe-to-close backdrop>
      <f7-page-content>
        <f7-block-title large>Kontakt</f7-block-title>
        <f7-block>
          <p>
            Softresource, spol. s r.o.
            <br />IČ: 066 14 329
            <br />Příkop 838/6, BRNO 602 00
            <br />vedená u Krajského soudu v Brně
            <br />pod spisovou značkou C 103195
            <br />
            <a href="mailto:analytics@softresource.cz" class="external">analytics@softresource.cz</a>
            <br />
            <a href="http://www.futurebooks.cz/" class="external" target="_blank">www.futurebooks.cz</a>
          </p>
        </f7-block>
      </f7-page-content>
    </f7-sheet>-->
  </div>
</template>

<script>
import "particles.js";
import { particleCFG } from "../config/particle";
export default {
  name: "Particles",
  mounted() {
    this.initParticles();
  },
  methods: {
    initParticles() {
      window.particlesJS("particles-js", particleCFG);
    }
  }
};
</script>

<style scoped>
.particles {
  height: 100%;
  display: relative;
}
#particles-js {
  background: #2980b9;
  /* background: #27ae60; */
  /* background: #d4af37; */
  height: 100%;
  width: 100%;
  position: fixed !important;
  top: 0;
  left: 0;
  z-index: -100;
  overflow: auto;
}
.content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
h1 {
  color: #fff;
  font-size: 6rem;
  font-family: Helvetica;
  margin-bottom: 0;
}
h3 {
  color: #fff;
  font-size: 2rem;
  text-align: center;
}
.links {
  font-family: Helvetica;
  position: absolute;
  bottom: 20px;
  right: 20px;
  color: #fff;
  background-color: rgba(255, 255, 255, 0.2);
  padding: 20px;
  border-radius: 5px;
}
a {
  color: #fff;
}
p {
  margin: 0 0 10px 0;
  font-weight: bold;
}

.contacts {
  font-family: Helvetica;
  position: absolute;
  bottom: 20px;
  left: 20px;
  color: #fff;
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 5px;
  width: 135px;
  height: 91px;
  display: flex;
  justify-content: center;
}
.contacts .button {
  align-self: center;
  font-weight: bold;
}
.modal {
  opacity: 0.7;
}
.modal a {
  color: #2980b9;
}

@media screen and (max-width: 425px) {
  h1 {
    font-size: 48px;
  }
  h3 {
    font-size: 14px;
  }
  .downArrow{
    width: 10vw !important;
  }
}


.downArrow{
	position: relative;
  width: 80px;
  padding-top: 150px;
  color: #fff;
  text-align: center;
  margin: 0 auto;
}
.bounce {
	-moz-animation: bounce 3s infinite;
	-webkit-animation: bounce 3s infinite;
	animation: bounce 3s infinite;
}
@-moz-keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    -moz-transform: translateY(0);
    transform: translateY(0);
  }
  40% {
    -moz-transform: translateY(-30px);
    transform: translateY(-30px);
  }
  60% {
    -moz-transform: translateY(-15px);
    transform: translateY(-15px);
  }
}
@-webkit-keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
  40% {
    -webkit-transform: translateY(-30px);
    transform: translateY(-30px);
  }
  60% {
    -webkit-transform: translateY(-15px);
    transform: translateY(-15px);
  }
}
@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    -moz-transform: translateY(0);
    -ms-transform: translateY(0);
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
  40% {
    -moz-transform: translateY(-30px);
    -ms-transform: translateY(-30px);
    -webkit-transform: translateY(-30px);
    transform: translateY(-30px);
  }
  60% {
    -moz-transform: translateY(-15px);
    -ms-transform: translateY(-15px);
    -webkit-transform: translateY(-15px);
    transform: translateY(-15px);
  }
}
</style>
